<!--
 * @Description: 事件详情event组件
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-04-12 16:51:16
 * @LastEditTime: 2019-05-10 09:16:24
 -->
<template>
    <section class="event-detail">
        <z-title title="事件详情" icon="icon-shijianxiangqing" />
        <div class="content" v-if="data">
            <i-form label-position="left">
                <div class="common-text">
                    <div class="form-item1" v-for="item in data.content.filter(item =>item.imgs==undefined)" :key="item.label">
                        <form-item :label="`${item.label}：`" v-if="item.type==1||item.type==3" class="form-item">
                            <div class="item-content" v-if="item.type==1">{{item.value}}</div>
                            <div v-else class="item-content">{{miment(Number(item.value)).format()}}</div>
                        </form-item>
                    </div>

                </div>
                <div class="common-text">
                    <div class="form-item1" v-for="item in data.content.filter(item =>item.imgs!=undefined)" :key="item.label">
                        <form-item :label="`${item.label}：`" v-if="item.type==2" class="form-item">
                            <div class="item-content" style="min-height:32px">{{item.value}}</div>
                            <div class="item-content">
                                <v-image :img="img.fileurl" v-for="(img,index) in item.imgs" class="file" :key="index" />
                            </div>
                            <div class="item-content">
                                <video-item :videosrc="item1.fileurl" v-for="(item1,index) in item.video" class="file" :key="index" />
                            </div>
                            <div class="item-content">
                                <v-file :file="file" v-for="(file,index) in item.files" class="file" :key="index" />
                            </div>
                            <div class="item-content">
                                <recording :sound="item2" v-for="(item2,index) in item.sound" class="file" :key="index" />
                            </div>
                        </form-item>
                    </div>
                </div>
            </i-form>
        </div>
    </section>
</template>
<script>
import miment from "miment";
import ZTitle from "../../../components/EventHeader"
import User from "../../../components/User.vue";
import VImage from "../../../components/VImage.vue";
import VFile from "../../../components/VFile.vue"
import Recording from "../../../components/Recording.vue"
import VideoItem from "../../../components/VideoItem.vue"
export default {
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            //时间格式化
            miment
        };
    },
    components: {
        ZTitle,
        VImage,
        VFile,
        VideoItem,
        Recording
    },
    computed: {},
}
</script>
<style lang='less' scoped>
.event-detail {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    .content {
        width: 100%;
        padding: 20px;
        padding-bottom: 30px;
        /deep/ .ivu-form-item {
            margin-bottom: 0px;
        }
        .common-text {
            display: flex;
            flex-wrap: wrap;
            width: 1020px;
            .form-item1 {
                width: 470px;
                padding-right: 50px;
            }
        }
    }
    .item-content {
        word-wrap: break-word;
        display: flex;
        flex-wrap: wrap;
        .file {
            margin-right: 10px;
        }
    }
}
</style>